import { InputNumber, Pagination, Select, Space } from 'antd'
import React, { useCallback, useState } from 'react'

const pageSizeOptions = [10, 20, 50, 100]

export const AppTablePagination = props => {
  const {
    total,
    current,
    pageSize,
    onChange,
    showSizeChanger = true,
    showQuickJumper = true,
    showLessItems = true,
    hideOnSinglePage = false,
  } = props || {}
  const [jumper, setJumper] = useState(null)

  const handleJump = useCallback(
    value => {
      if (!value) return
      const maxPage = Math.ceil(total / pageSize)
      const page = Math.min(Math.max(1, value), maxPage)
      if (page === current) return
      onChange(page, pageSize)
    },
    [onChange, pageSize, total, current]
  )

  if (hideOnSinglePage && total <= pageSize) {
    return null
  }

  return (
    <div className="customPaginationWrapper">
      <Space size={8}>
        {showSizeChanger && (
          <div className="left-content-box">
            <span>Hiển thị</span>
            <Select
              value={pageSize}
              options={pageSizeOptions.map(size => ({
                label: `${size} / trang`,
                value: size,
              }))}
              onChange={size => onChange(1, size)}
            />
          </div>
        )}

        {showQuickJumper && (
          <div className="left-content-box">
            <span>Đi đến</span>
            <InputNumber
              min={1}
              value={jumper}
              onChange={setJumper}
              placeholder={`${current}`}
              onPressEnter={() => handleJump(jumper)}
              onBlur={() => handleJump(jumper)}
            />
          </div>
        )}
      </Space>

      <Pagination
        onChange={onChange}
        total={total}
        pageSize={pageSize}
        current={current}
        showSizeChanger={false}
        showQuickJumper={false}
        showLessItems={showLessItems}
        hideOnSinglePage={hideOnSinglePage}
        className="customPagination"
      />
    </div>
  )
}
